import React from 'react';

const Footer = () => (
  <footer className="px-6 py-3 shrink-0 border-t border-line bg-ink">
    <p className="text-[11.5px] text-fg-faint">© {new Date().getFullYear()} Cantera Digital · Plataforma de agentes</p>
  </footer>
);

export default Footer;
